export function getTenantDomainFromURL(url) {
  return new URL(url).hostname.split(".")[0];
}
